module.exports = __webpack_public_path__ + "static/media/UsersEmployee.3aafe904.svg";